import VueRouter from 'vue-router';
import moment from 'moment';
import { parseWeek, formatWeek } from '@/helpers';
import routes from './routes';
import { setupUserInStore, requiresAuthGuard, authenticatedGuard, rolesGuard } from './guards';
import store from '../../store';

const router = new VueRouter({
  mode: 'history',
  routes,
});

const getDefaultWeek = () => formatWeek(moment());

// TODO: reduce complexity of method below
// eslint-disable-next-line complexity
const getWeekString = (to) => {
  if (to.params.week) {
    const weekParam = to.params.week.toLowerCase();
    if (to.path.indexOf('/menu') >= 0) {
      switch (weekParam) {
        case 'previous':
          return formatWeek(moment().subtract(1, 'week'));
        case 'next':
          return formatWeek(moment().add(1, 'week'));
        default:
          return getDefaultWeek();
      }
    } else if (to.path.indexOf('/admin') >= 0) {
      const week = parseWeek(weekParam);
      if (week.isValid()) {
        return formatWeek(week);
      }
    }
  }
  return getDefaultWeek();
};

const isValidMenuWeek = (week) => {
  const validMenuWeeks = ['previous', 'next'];
  return validMenuWeeks.includes(week);
};

const isValidAdminWeek = (week) => parseWeek(week).isValid();

// TODO: reduce complexity of method below
// eslint-disable-next-line complexity
const processWeek = (to, from, next, store) => {
  if (!to.params.week) {
    store.dispatch('weeklyMenu/setSelectedWeek', getDefaultWeek());
    return true;
  }

  const weekParam = to.params.week.toLowerCase();
  if (to.path.indexOf('/menu') >= 0 && !isValidMenuWeek(weekParam)) {
    next({ path: '/menu', replace: true });
    return false;
  }
  if (to.path.indexOf('/admin') >= 0 && !isValidAdminWeek(weekParam)) {
    next({ path: '/admin', replace: true });
    return false;
  }

  const week = getWeekString(to);
  store.dispatch('weeklyMenu/setSelectedWeek', week);
  return true;
};

router.beforeEach(setupUserInStore);
router.beforeEach(requiresAuthGuard);
router.beforeEach(authenticatedGuard);
router.beforeEach(rolesGuard);

router.beforeEach(async (to, from, next) => {
  // TODO: Document this function...
  // https://wizeline.atlassian.net/browse/FM-657
  if (!processWeek(to, from, next, store)) return;

  next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js